import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { VehicleCategoryInterface } from '../../models/dashboard/driver-setup/vehicle-category';

interface IInitialState {
  vehicleCategoryData?: VehicleCategoryInterface[];
}

const initialState: IInitialState = {
  vehicleCategoryData: undefined,
};

const vehicleCategorySlice = createSlice({
  name: 'vehicleCategorySlice',
  initialState,
  reducers: {
    setVehicleCategoryData(state, action: PayloadAction<VehicleCategoryInterface[]>) {
      state.vehicleCategoryData = action.payload;
    },
  },
});

export const vehicleCategoryActions = vehicleCategorySlice.actions;
export default vehicleCategorySlice.reducer;
